module.exports = __webpack_public_path__ + "static/media/28DGC3.2da19f71.jpg";